import script from "./PaginacionButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginacionButtons.vue?vue&type=script&setup=true&lang=js"

import "./PaginacionButtons.vue?vue&type=style&index=0&id=1a1e0a0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a1e0a0c"]])

export default __exports__